import { IFieldType } from "store/reducers/bundlePromotion.reducers";

export const getCollectionFields = (collections: any[] = []): IFieldType[] => {
  const parent = collections.find((c: any) => c.type === "parent");
  const gift = collections.find((c: any) => c.type === "freeGift");

  const fields: IFieldType[] = [];

  if (parent?.sku?.length) {
    fields.push({
      name: "ParentSkuList",
      value: parent.sku,
    });
  }

  if (gift?.sku?.length) {
    fields.push({
      name: "FreeGiftSkuList",
      value: gift.sku,
    });
  }

  if (parent?.text?.en?.shortText) {
    fields.push({
      name: "ShortText",
      value: parent.text.en.shortText,
    });
  }

  if (parent?.text?.ar?.shortText) {
    fields.push({
      name: "ShortText",
      value: parent.text.ar.shortText,
    });
  }

  return fields;
};

export const flattenBundleCampaignDetails = (
    obj: Record<string, any>
  ): IFieldType[] => {
    const result: IFieldType[] = [];

    function traverse(current: any): void {
      for (const key in current) {
        if (!Object.prototype.hasOwnProperty.call(current, key)) continue;

        const value = current[key];

        if (
          value !== null &&
          typeof value === "object" &&
          !Array.isArray(value)
        ) {
          traverse(value);
        } else {
          const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
          result.push({ name: capitalizedKey, value });
        }
      }
    }
    traverse(obj);
    return result;
  }
